namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class DetailAdmMotorZpracovaniEPA extends GContentBase {
        private dataListDescription: Gordic.General.ApplicationInterface.GDataListDescription;
        private data: Gordic.AdmIsl.Interface.GAdmMotorZpracovaniEPAReadDto;
        private newRecord: boolean;
        private detailObj: DetailAdmMotorZpracovaniEPAObj & GContent;

        // hodnota parametru adx_checkiconad 
        private currentFilter: any;
        private gridRc: Gordic.Components.GridRC<any>;
        private createPreviousAndNextAction: boolean;

        onDetailBuilderInit(builder: Gordic.Gin.DetailBuilder.GDetailBuilder) {
            this.detailObj = $.extend(this, new DetailAdmMotorZpracovaniEPAObj());
            this.detailObj.createBase({
                contentName: "detailAdmMotorZpracovaniEPA",
                contentCaption: "jres:33001026", //RC 33001026 : Automatický motor
                newRecord: this.newRecord,
                data: this.data,
                dataListDescription: this.dataListDescription,
                addPlatnost: false,
                currentFilter: this.currentFilter,
                gridRc: this.gridRc,
                createPreviousAndNextAction: this.createPreviousAndNextAction,
            });
            var tabs: Gordic.Gin.DetailBuilder.TabParamsId[] | ObjectLiteral<Gordic.Gin.DetailBuilder.TabParams> | null = [];
            if (this.newRecord == false)
                tabs.push(this.detailObj.getAuditPristupuTab());
            var groups: IGTabGroupOptions[] = [];
            if (this.newRecord == false)
                groups.push(this.detailObj.getAuditPristupuGroup());
            builder.withComponent<this>("DetailAdmMotorZpracovaniEPA", {
                statusBar: this.detailObj.createStatusBar(),
                menuBar: this.detailObj.createMenuBar(),
                headerForm: this.detailObj.createFormComplet(),
                commandBar: this.detailObj.createCommandBar(),
                sidePanels: [/*this.detailObj.getAuditPristupu(),*/ this.detailObj.getPoznamky()],
                tabs: tabs,
                tabGroups: groups,
            })
        }

        onContentReady() {
            this.detailObj.finishBuilder()
        }

        closing() {
            return this.detailObj.closeAction();
        }
    }


    export class DetailAdmMotorZpracovaniEPAObj extends GAdmDetailBase<Gordic.AdmIsl.Interface.GAdmMotorZpracovaniEPAReadDto> {
        typ_mbx: number;

        create() {

        }

        textPopis(): string | undefined | null {
            return `${this.data.nazev}`
        }

        setSxsDetail(): string {
            return `${this.data.ixs_epa}`;
        }

        saveData(data: Gordic.AdmIsl.Interface.GAdmMotorZpracovaniEPASaveDto, close: boolean) {
            this.cnt.isl.AdmMotorZpracovaniEPA.upsert({ data: data }).get().then((output: any) => {
                if (output.result.kind === Utils.GOperationResultKind.Success) {
                    this.pendingAction("actSave", true)
                    this.data = output.data;
                    this.metadata = this.data.MetaData;
                    this.updateGridBase().done(() => {
                        this.showSuccessSave(close);
                        if (close == true) {
                            this.closeAction(true).done(() => { this.cnt.close() });
                        } else
                            this.reloadDataBase();
                    });
                } else {
                    this.checkErrors(output.result.errors)
                    this.pendingAction("actSave", false)
                }
            }).catch((err) => {
                this.pendingAction("actSave", false)
                throw err;
            })
        }

        reloadData(filterObj: any, dataObj: any) {
            filterObj.typ_mbx = this.typ_mbx;
            this.openDetailOrModalWindow("Gordic.Adm.WebControls.DetailAdmMotorZpracovaniEPA", filterObj, dataObj);
        }

        updateGrid(filter: any, grid: any): any {
            return this.cnt.isl.AdmMotorZpracovaniEPA.list({
                filters: filter,
                fragments: [(this.typ_mbx == 30 || this.typ_mbx == 50) ? "ds" : "mb"]
            }).getView().promise()
        }

        createTitle(): string {
            if (this.options.newRecord == true)
                return "jres:32000121";
            return `${this.options.contentCaption} - ${this.textPopis()}`
        }

        createMenuBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                "actEdit*",
                { action: this.cnt.actions.actSave, favorite: true, actionContext: { close: false } },
                "actCancelEdit*",
                { action: this.cnt.actions.actPrevious, favorite: true, align: "opposite" },
                { action: this.cnt.actions.actNext, favorite: true, align: "opposite" }
            ]
        }

        createCommandBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                { caption: "jres:32000161", action: this.cnt.actions.actSave, customClass: "g-button--primary", favorite: true, actionContext: { close: true } },
                "actClose*"
            ]
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return null;
        }

        setEditMode(editMode: boolean) {

        }

        createForm() {
            this.MakeField("ixs_epa", {
                flag: this.createFlagNemenne()
            })
            this.MakeSelectField("mailbox", Gordic.Prefabs.Select.admGinsmbx(), {
                flag: this.createFlagNemenne(),
                model: "model.mailbox=value.mailbox"
            })
            this.MakeField("nazev")
            this.MakeField("poznamka")
            this.MakeField("adr_odes")
            this.MakeField("subj_start")
            this.MakeField("subj_obsah")
            this.MakeField("poradi")
            this.MakeSelectField("ixs_typ", Gordic.Prefabs.Select.sslstyp(), { model: "model.ixs_typ=value.ixs_typ" })
            this.MakeSelectField("zpusob_dor", Gordic.Prefabs.Select.wflczpd(), { model: "model.zpusob_dor=value.zpusob_dor" })
            this.MakeSelectField("ixs_fsk", Gordic.Prefabs.Select.wflsfsk(), { model: "model.ixs_fsk=value.ixs_fsk" })
            this.MakeSelectField("aktivita", Gordic.Prefabs.Select.gincakt());
            this.MakeField("dat_zmena");
            this.MakeSelectField("zmenu_prov", Gordic.Prefabs.Select.ginszmp(), { model: "model.zmenu_prov=value.ixs_zmp" });
        }
    }
}